export default "__VITE_ASSET__DoHkILQD__"